interface BadgeProps {
  active?: boolean;
  children: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ active, children, className }) => {
  return (
    <p
      className={`rounded-full py-0.5 px-[0.3125rem] text-[0.8125rem] leading-[1rem] font-semibold
        ${
          active
            ? "text-button-text bg-button"
            : "text-plain-foreground bg-plain-background"
        }
        ${className}
      `}
    >
      {children}
    </p>
  );
};

export default Badge;
